const AddBookingFormFields = {
  FUNERAL: {
    clientFields: [
      {
        name: "source_of_booking",
        label: "Source of Booking",
        type: "select",
        options: [
          { value: "walk_in", label: "Walk In" },
          { value: "direct_call", label: "Direct Call" },
          { value: "website", label: "Website" },
          { value: "referral", label: "Referral" },
          { value: "social_media", label: "Social Media" },
          { value: "client_portal", label: "Client Portal" },
        ],
      },

      { name: "first_name", label: "First Name", type: "text", required: true },

      {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        disabled: true,
      },
      {
        name: "phone",
        label: "Phone",
        type: "tel",
        required: true,
        disabled: true,
        component: "MuiTelInput",
      },
      {
        name: "relationship_to_deceased",
        label: "Relationship to Deceased",
        type: "select",
        options: [
          { value: "son", label: "Son" },
          { value: "daughter", label: "Daughter" },
          { value: "father", label: "Father" },
          { value: "mother", label: "Mother" },
          { value: "brother", label: "Brother" },
          { value: "husband", label: "Husband" },
          { value: "wife", label: "Wife" },
          { value: "sister", label: "Sister" },
          { value: "son_in_law", label: "Son-in-law" },
          { value: "daughter_in_law", label: "Daughter-in-law" },
          { value: "friend", label: "Friend" },
          { value: "cousin", label: "Cousin" },
          { value: "grand_son", label: "Grand-Son" },
          { value: "grand_daughter", label: "Grand-daughter" },
          { value: "other", label: "Other" },

        ],
      },
      {
        name: "special_request",
        label: "Special Request",
        type: "multiline",
        rows: 3,
      },
      { name: "service_notes", label: "Notes", type: "multiline", rows: 3 },
    ],
    serviceFields: [
      {
        name: "deceased_salutation",
        label: "Salutation",
        type: "select",
        options: [
          { value: "Mr", label: "Mr" },
          { value: "Mrs", label: "Mrs" },
          { value: "Ms", label: "Ms" },
          { value: "Dr", label: "Dr" },
          { value: "Rev", label: "Rev" },
          { value: "Prof", label: "Prof" },
          { value: "Sir", label: "Sir" },
          { value: "Fr", label: "Fr" },
          { value: "Pastor", label: "Pastor" },
          { value: "Hon", label: "Hon" },
        ],
      },
      {
        name: "deceased_name",
        label: "Deceased Name",
        type: "text",
        required: true,
      },
      {
        name: "deceased_surname",
        label: "Deceased Surname",
        type: "text",
        required: true,
      },
      { name: "second_name", label: "Other Name", type: "text" },
      { name: "nickname", label: "NickName", type: "text" },
      {
        name: "gender",
        label: "Gender",
        type: "select",
        options: [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
        ],
      },
      {
        name: "type_of_service",
        label: "Type of service",
        type: "select",
        options: [
          { value: "Funeral", label: "Funeral" },
          { value: "Celebration", label: "Celebration of life" },
          { value: "Burial", label: "Burial" },
        ],
      },
      {
        name: "religion",
        label: "Religion",
        type: "select",
        options: [
          { value: "christianity", label: "Christianity" },
          { value: "islam", label: "Islam" },
          { value: "hinduism", label: "Hinduism" },
          { value: "buddhism", label: "Buddhism" },
          { value: "judaism", label: "Judaism" },
          { value: "traditional_african", label: "Traditional African" },
          { value: "other", label: "Other" },
        ],
      },
      {
        name: "denomination",
        label: "Denomination",
        type: "text",
      },
      { name: "date_of_birth", label: "Sunrise", type: "date" },
      { name: "date_of_death", label: "Sunset", type: "date" },
      {
        name: "date_of_service",
        label: "Date of Service",
        type: "date",
        required: true,
      },
      { name: "start_time", label: "Start Time", type: "time", required: true },
      { name: "end_time", label: "End Time", type: "time", tooltip: "2 hours after start time." },
      { name: "venue_name", label: "Venue", type: "text" },
      {
        name: "address_one",
        label: "Address One",
        type: "text",
        disabled: true,
      },
      {
        name: "address_two",
        label: "Address Two",
        type: "text",
        disabled: true,
      },
      { name: "suburb", label: "Suburb", type: "text", disabled: true },
      { name: "city", label: "City", type: "text", disabled: true },
    ],
  },
  FUNERAL_HOME: {
    clientFields: [
      {
        name: "source_of_booking",
        label: "Source of Booking",
        type: "select",
        options: [
          { value: "walk_in", label: "Walk In" },
          { value: "direct_call", label: "Direct Call" },
          { value: "website", label: "Website" },
          { value: "referral", label: "Referral" },
          { value: "social_media", label: "Social Media" },
          { value: "client_portal", label: "Client Portal" },
        ],
      },

      {
        name: "company_name",
        label: "Company Name",
        type: "select",
        options: [],
      },
      { name: "email", label: "Representative Email", type: "email", disabled: true },
      {
        name: "phone",
        label: "Representative Phone",
        type: "tel",
        disabled: true,
      },
      { name: "family_contact_name", label: "Family Contact", type: "text" },
      {
        name: "special_request",
        label: "Special Request",
        type: "multiline",
        rows: 3,
      },
      { name: "service_notes", label: "Notes", type: "multiline", rows: 3 },
    ],
    branchesByCompany: {
      old_mutual: ["Harare CBD", "Bulawayo", "Masvingo"],
      first_mutual: ["Harare CBD", "Blank 1"],
      serene: ["Harare CBD", "Blank 1"],
    },
    serviceFields: [
      {
        name: "deceased_salutation",
        label: "Salutation",
        type: "select",
        options: [
          { value: "Mr", label: "Mr" },
          { value: "Mrs", label: "Mrs" },
          { value: "Ms", label: "Ms" },
          { value: "Dr", label: "Dr" },
          { value: "Rev", label: "Rev" },
          { value: "Prof", label: "Prof" },
          { value: "Sir", label: "Sir" },
          { value: "Fr", label: "Fr" },
          { value: "Pastor", label: "Pastor" },
          { value: "Hon", label: "Hon" },
        ],
      },
      {
        name: "deceased_name",
        label: "Deceased Name",
        type: "text",
        required: true,
      },
      {
        name: "deceased_surname",
        label: "Deceased Surname",
        type: "text",
        required: true,
      },
      { name: "second_name", label: "Other Name", type: "text" },
      { name: "nickname", label: "NickName", type: "text" },
      {
        name: "gender",
        label: "Gender",
        type: "select",
        options: [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
        ],
      },
      {
        name: "type_of_service",
        label: "Type of service",
        type: "select",
        options: [
          { value: "Funeral", label: "Funeral" },
          { value: "Celebration", label: "Celebration of life" },
          { value: "Burial", label: "Burial" },
        ],
      },
      {
        name: "religion",
        label: "Religion",
        type: "select",
        options: [
          { value: "christianity", label: "Christianity" },
          { value: "islam", label: "Islam" },
          { value: "hinduism", label: "Hinduism" },
          { value: "buddhism", label: "Buddhism" },
          { value: "judaism", label: "Judaism" },
          { value: "traditional_african", label: "Traditional African" },
          { value: "other", label: "Other" },
        ],
      },
      {
        name: "denomination",
        label: "Denomination",
        type: "text",
      },

      { name: "date_of_birth", label: "Sunrise", type: "date" },
      { name: "date_of_death", label: "Sunset", type: "date" },
      {
        name: "date_of_service",
        label: "Date of Service",
        type: "date",
        required: true,
      },
      { name: "start_time", label: "Start Time", type: "time", required: true },
      { name: "end_time", label: "End Time", type: "time", tooltip: "2 hours after start time." },
      { name: "venue_name", label: "Venue", type: "text" },
      { name: "address_one", label: "Address One", type: "text" },
      { name: "address_two", label: "Address Two", type: "text" },
      { name: "suburb", label: "Suburb", type: "text" },
      { name: "city", label: "City", type: "text" },
    ],
  },
  CHURCH: {
    clientFields: [
      {
        name: "source_of_booking",
        label: "Source of Booking",
        type: "select",
        options: [
          { value: "walk_in", label: "Walk In" },
          { value: "direct_call", label: "Direct Call" },
          { value: "website", label: "Website" },
          { value: "referral", label: "Referral" },
          { value: "social_media", label: "Social Media" },
          { value: "client_portal", label: "Client Portal" },
        ],
      },

      { name: "first_name", label: "First Name", type: "text", required: true },
      { name: "surname", label: "Surname", type: "text", required: true },
      { name: "email", label: "Email", type: "email", required: true },
      {
        name: "phone",
        label: "Phone",
        type: "tel",
        required: true,
        component: "MuiTelInput",
      }, // Added component
      {
        name: "special_request",
        label: "Special Request",
        type: "multiline",
        rows: 3,
      },
      {
        name: "service_notes",
        label: "Notes",
        type: "multiline",
        rows: 3,
      },
    ],
    serviceFields: [
      {
        name: "church_name",
        label: "Name of church",
        type: "text",
        required: true,
      },
      {
        name: "leader_preacher_name",
        label: "Leader Preacher's Name",
        type: "text",
      },
      {
        name: "leader_preacher_surname",
        label: "Leader Preacher's Surname",
        type: "text",
      },
      { name: "title", label: "Title", type: "text" },
      { name: "preacher_name", label: "Preacher's Name", type: "text" },
      { name: "preacher_surname", label: "Preacher's Surname", type: "text" },
      { name: "start_time", label: "Start Time", type: "time", required: true },
      { name: "end_time", label: "End Time", type: "time", tooltip: "2 hours after start time." },
      { name: "date_of_service", label: "Date", type: "date", required: true },
      {
        name: "church_phone",
        label: "Church Phone",
        type: "tel",
        component: "MuiTelInput",
      }, // Added component
      { name: "church_email", label: "Church Email", type: "email" },
      { name: "venue_name", label: "Venue", type: "text" },
      {
        name: "address_one",
        label: "Address One",
        type: "text",
        disabled: true,
      },
      {
        name: "address_two",
        label: "Address Two",
        type: "text",
        disabled: true,
      },
      { name: "suburb", label: "Suburb", type: "text", disabled: true },
      { name: "city", label: "City", type: "text", disabled: true },
    ],
  },
  CONFERENCE: {
    clientFields: [
      {
        name: "source_of_booking",
        label: "Source of Booking",
        type: "select",
        options: [
          { value: "walk_in", label: "Walk In" },
          { value: "direct_call", label: "Direct Call" },
          { value: "website", label: "Website" },
          { value: "referral", label: "Referral" },
          { value: "social_media", label: "Social Media" },
          { value: "client_portal", label: "Client Portal" },
        ],
      },

      { name: "first_name", label: "First Name", type: "text", required: true },
      { name: "surname", label: "Surname", type: "text", required: true },
      { name: "email", label: "Email", type: "email", required: true },
      {
        name: "phone",
        label: "phone",
        type: "tel",
        required: true,
        component: "MuiTelInput",
      },
      {
        name: "special_request",
        label: "Special Request",
        type: "multiline",
        rows: 3,
      },
      { name: "service_notes", label: "Notes", type: "multiline", rows: 3 },
    ],

    serviceFields: [],
  },
  EVENT: {
    clientFields: [
      {
        name: "source_of_booking",
        label: "Source of Booking",
        type: "select",
        options: [
          { value: "walk_in", label: "Walk In" },
          { value: "direct_call", label: "Direct Call" },
          { value: "website", label: "Website" },
          { value: "referral", label: "Referral" },
          { value: "social_media", label: "Social Media" },
          { value: "client_portal", label: "Client Portal" },
        ],
      },

      {
        name: "branch_name",
        label: "Branch Name",
        type: "select",
        options: [],
      },
      { name: "branch_wrap", label: "Branch Representative", type: "text" },
      { name: "email", label: "Representative Email", type: "email" },
      {
        name: "phone",
        label: "Representative Phone",
        type: "tel",
        component: "MuiTelInput",
      }, // Added component
      {
        name: "special_request",
        label: "Special Request",
        type: "multiline",
        rows: 3,
      },
      { name: "service_notes", label: "Notes", type: "multiline", rows: 3 },
    ],
    serviceFields: [
      { name: "content_type", label: "Type of Content", type: "text" },
      { name: "event_name", label: "Event Name", type: "text", required: true },
      { name: "sub_title", label: "Subtitle", type: "text" },
      { name: "hosts", label: "Host Name", type: "text" },
      { name: "host_surname", label: "Host Surname", type: "text" },
      { name: "guests", label: "Guest Name", type: "text" },
      { name: "guest_surname", label: "Guest Surname", type: "text" },
      { name: "start_time", label: "Start Time", type: "time", required: true },
      { name: "end_time", label: "End Time", type: "time", tooltip: "2 hours after start time." },
      { name: "date_of_service", label: "Date", type: "date", required: true },
      { name: "venue_name", label: "Venue", type: "text" },
      { name: "address_one", label: "Address One", type: "text" },
      { name: "address_two", label: "Address Two", type: "text" },
      { name: "suburb", label: "Suburb", type: "text" },
      { name: "city", label: "City", type: "text" },
    ],
  },
  OTHER: {
    clientFields: [
      {
        name: "source_of_booking",
        label: "Source of Booking",
        type: "select",
        options: [
          { value: "walk_in", label: "Walk In" },
          { value: "direct_call", label: "Direct Call" },
          { value: "website", label: "Website" },
          { value: "referral", label: "Referral" },
          { value: "social_media", label: "Social Media" },
          { value: "client_portal", label: "Client Portal" },
        ],
      },

      {
        name: "client_salutation",
        label: "Salutation",
        type: "select",
        options: [
          { value: "Mr", label: "Mr" },
          { value: "Mrs", label: "Mrs" },
          { value: "Ms", label: "Ms" },
          { value: "Dr", label: "Dr" },
          { value: "Rev", label: "Rev" },
          { value: "Prof", label: "Prof" },
          { value: "Sir", label: "Sir" },
          { value: "Fr", label: "Fr" },
          { value: "Pastor", label: "Pastor" },
          { value: "Hon", label: "Hon" },
        ],
      },
      { name: "first_name", label: "First Name", type: "text", required: true },
      { name: "surname", label: "Surname", type: "text", required: true },
      { name: "email", label: "Email", type: "email", required: true },
      {
        name: "phone",
        label: "phone",
        type: "tel",
        required: true,
        component: "MuiTelInput",
      },
      {
        name: "special_request",
        label: "Special Request",
        type: "multiline",
        rows: 3,
      },
      { name: "service_notes", label: "Notes", type: "multiline", rows: 3 },
    ],
    serviceFields: [
      { name: "content_type", label: "Type of Content", type: "text" },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "sub_title", label: "Subtitle", type: "text" },
      { name: "hosts", label: "Host Name", type: "text" },

      { name: "guests", label: "Guest Name", type: "text" },

      { name: "start_time", label: "Start Time", type: "time", required: true },
      { name: "end_time", label: "End Time", type: "time", tooltip: "2 hours after start time." },
      {
        name: "start_date_of_event",
        label: "Date",
        type: "date",
        required: true,
      },
      { name: "venue_name", label: "Venue", type: "text" },
      { name: "address_one", label: "Address One", type: "text" },
      { name: "address_two", label: "Address Two", type: "text" },
      { name: "suburb", label: "Suburb", type: "text" },
      { name: "city", label: "City", type: "text" },
    ],
  },
};

export default AddBookingFormFields;
